<template>
  <v-expansion-panel v-if="expanded">
    <v-expansion-panel-header>
      <slot name="header"></slot>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mx-0 py-0">
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
  <div v-else></div>
</template>
<script>
export default {
  props: {
    expanded: { type: Boolean, default: false },
  },
};
</script>
